import request from "@/plugins/axios";

export function findAllUser(pageNumber,pageSize,userId) {
    let params = new URLSearchParams()
    params.append("pageNumber",(pageNumber - 1).toString())
    params.append("pageSize",pageSize.toString())
    if (userId!=null) {
        params.append("userId",userId.toString())
    }
    return request.get("/admin/users",{params});
}

export function modifyAuthorityType(userId, authorityType) {
    let data = new URLSearchParams()
    data.append("authorityType", authorityType)
    return request.put(`/admin/user/authority/${userId}`, data)
}


export function findSimilarUsername(username) {
    let params = new URLSearchParams();
    if (username != null) {
       params.append("subUsername",username)
    }

    return request.get("/public/usernames",{params})
}
